import { createSlice } from "@reduxjs/toolkit";
import { cityIOSettings } from "../../settings/settings"

export const dataSlice = createSlice({
  name: "dataState",
  initialState: {
    layers: [
      {
        id: 'blocks',
        type: 'geojson',
        // Estático en S3/CloudFront: se carga una vez (sin bbox dinámico).
        url: `${cityIOSettings.cdnURL}/static/manzanas.geojson`,
        geojson: null,
        data: null,
        visible: true,
        supportsBbox: false,
      },
      {
        id: 'albergues',
        type: 'icon',
        url: `${cityIOSettings.cdnURL}/static/albergues.geojson`,
        geojson: null,
        data: null,
        visible: true,
      },
      {
        id: 'acopios',
        type: 'icon',
        url: `${cityIOSettings.cdnURL}/static/acopios.geojson`,
        geojson: null,
        data: null,
        visible: true,
      },
      {
        id: 'alimentacion',
        type: 'icon',
        url: `${cityIOSettings.cdnURL}/static/alimentacion.geojson`,
        geojson: null,
        data: null,
        visible: true,
      },
      {
        id: 'educacion',
        type: 'icon',
        url: `${cityIOSettings.cdnURL}/static/educacion.geojson`,
        geojson: null,
        data: null,
        visible: false,
      },
      {
        id: 'salud',
        type: 'icon',
        url: `${cityIOSettings.cdnURL}/static/salud.geojson`,
        geojson: null,
        data: null,
        visible: false,
      },
      {
        id: 'focosHistoricos',
        type: 'geojson',
        url: `${cityIOSettings.cdnURL}/static/focos_historicos.geojson`,
        geojson: null,
        data: null,
        visible: false,
        supportsBbox: false,
      },
      {
        id: 'focos',
        type: 'icon',
        // Dinámico: generado por Lambda cada ~10 min.
        url: `${cityIOSettings.cdnURL}/dynamic/focos.geojson`,
        geojson: null,
        data: null,
        visible: true,
      },
      {
        id: 'area_focos',
        type: 'geojson',
        // Dinámico: ahora archivo propio (ya no se deriva de focos.coverage).
        url: `${cityIOSettings.cdnURL}/dynamic/area_focos.geojson`,
        geojson: null,
        data: null,
        visible: true,
      },
      {
        id: 'jams',
        type: 'geojson',
        // Dinámico: generado por Lambda cada ~2 min.
        url: `${cityIOSettings.cdnURL}/dynamic/jams.geojson`,
        geojson: null,
        data: null,
        visible: true,
      },
    ],
    dataIsDone: false,
    timeRange: {
      startDate: 17,
      endDate: 26
    }
  },
  reducers: {
    updateLayers: (state, action) => {
      state.layers = action.payload;
    },
    toggleLayersIsDone: (state, action) => {
      state.dataIsDone = action.payload;
    },
    toggleLayerVisibility: (state, action) => {
      const layer = state.layers.find(l => l.id === action.payload);
      if (layer) {
        layer.visible = !layer.visible;
      }
    },
    updateLayerData: (state, action) => {
      const { layerId, data } = action.payload;
      const layer = state.layers.find(l => l.id === layerId);
      if (layer) {
        layer.geojson = data;
        layer.data = data;
      }
    },
    setTimeRange: (state, action) => {
      state.timeRange = action.payload;
    },
  },
});

export const {
  updateLayers,
  toggleLayersIsDone,
  toggleLayerVisibility,
  updateLayerData,
  setTimeRange,
} = dataSlice.actions;
export default dataSlice.reducer;
